import { enrichConvertersRegistry } from '../../utils/convertersRegistry'
import { overflowConverterMap } from './overflowPropsToCss'

/**
 * Enriches the converters registry with all Overflow style property converters.
 * Overflow converters handle CSS overflow property with separate x and y values.
 */
export function enrichOverflowConverters(): void {
	// Register all overflow converters by their type discriminants
	Object.entries(overflowConverterMap).forEach(([key, converter]) => {
		enrichConvertersRegistry(key, converter)
	})
}
